import React from 'react';
import {
    Card, CardHeader, CardBody, CardFooter,
    CardLink, CardText,
    Modal, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import FileDownload from "components/Varios/FileDownload.js";

export default class CardPublicacionesRealizadas extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    parseDate(date) {
        if (date) {
            date = new Date(date)
            return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
        }
        return null
    }

    render() {

        return (
            <div className="col-md-4 col-xs-4" style={{ paddingBottom: "15px" }}>
                <Card>
                    <CardBody>
                        <CardText>
                            <b>{this.props.objeto.titulo}</b>
                            <br />
                            <br />
                            <span className="spanCard">TIPO DE PUBLICACIÓN: </span>{this.props.objeto.strTipopublicacion}
                            <br />
                            <span className="spanCard">AÑO: </span>{this.props.objeto.anio}
                            {
                                ['A', 'S', 'C'].includes(this.props.objeto.tipopublicacion) ?
                                    <>
                                        <br />
                                        <span className="spanCard">NOMBRE DE REVISTA / EVENTO: </span>{this.props.objeto.nombrerevista}
                                    </>
                                    :
                                    null
                            }
                            {/*<br />*/}
                            {/*<span className="spanCard">TIPO DE PARTICIPACIÓN: </span>{this.props.objeto.strTipoparticipacion}*/}
                            {
                                ["ARTÍCULO DE DIFUSIÓN", "ARTÍCULO CIENTÍFICO"].includes(this.props.objeto.tipopublicacion) ?
                                    <>
                                        <br />
                                        <span className="spanCard">ESTADO DE LA PUBLICACIÓN: </span>{this.props.objeto.strEstadopublicacion}
                                        {
                                            this.props.objeto.nombrerevista ?
                                                <>
                                                    <br />
                                                    <span className="spanCard">NOMBRE DE LA REVISTA: </span>{this.props.objeto.nombrerevista}
                                                </>
                                                :
                                                null
                                        }
                                        {
                                            this.props.objeto.strTipoindexacion ?
                                                <>
                                                    <br />
                                                    <span className="spanCard">B.D REVISTAS INDEXADAS: </span>{this.props.objeto.strTipoindexacion}
                                                </>
                                            : 
                                            null
                                        }
                                    </>
                                    :
                                    null
                            }
                            {
                                ["LIBRO O CAPITULO DE LIBRO"].includes(this.props.objeto.tipopublicacion) ?
                                    <>
                                        {
                                            this.props.objeto.strTipoindexacion ?
                                                <>
                                                    <br />
                                                    <span className="spanCard">B.D REVISTAS INDEXADAS: </span>{this.props.objeto.strTipoindexacion}
                                                </>
                                                :
                                                null
                                        }
                                    </>
                                    :
                                    null
                            }
                            {
                                this.props.objeto.nroISBN ?
                                    <>
                                        <br />
                                        <span className="spanCard">CÓDIGO: </span>{this.props.objeto.nroISBN}
                                    </>
                                    :
                                    null
                            }
                            {
                                this.props.objeto.factorimpacto ?
                                    <>
                                        <br />
                                        <span className="spanCard">FACTOR IMPACTO: </span>{this.props.objeto.factorimpacto}
                                    </>
                                    :
                                    null
                            }
                            {
                                this.props.objeto.institucion ?
                                    <>
                                        <br />
                                        <span className="spanCard">LUGAR O CENTRO / EDITOR(A): </span>{this.props.objeto.institucion}
                                    </>
                                    :
                                    null
                            }
                            {
                                this.props.objeto.urlpublicacion ?
                                    <>
                                        <br />
                                        <span className="spanCard">URL PUBLICACIÓN: </span><a href={this.props.objeto.urlpublicacion} target="_blank">Clic aquí</a>
                                    </>
                                    :
                                    null
                            }
                            
                        </CardText>
                    </CardBody>
                    <CardFooter className="text-muted">
                        <div style={{ float: "left" }}>
                            {this.props.number}
                        </div>
                        <div style={{ float: "right" }}>
                            <FileDownload files={this.props.evidencias} card={true} icon="download" />
                        </div>
                    </CardFooter>
                </Card>
            </div>
        )

    }
}